import React, { SVGProps } from 'react';

const StakingPoolIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="StakingPoolIcon">
    <path
      d="M8 15.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15ZM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-3H5V5h2.25V3.5h1.5V5h.75A1.875 1.875 0 0 1 11 8a1.875 1.875 0 0 1-1.5 3h-.75v1.5h-1.5V11ZM6.5 8.75v.75h3a.375.375 0 0 0 0-.75h-3Zm0-2.25v.75h3a.375.375 0 0 0 0-.75h-3Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--dropdownBackground)"
      strokeWidth={0.4}
    />
  </svg>
);

export default StakingPoolIcon;
